
import FormBase from 'jsx/components/core/form/components/FormBase';
import PageTitle from 'jsx/components/core/form/components/PageTitle';
import AnalysisGroups from 'jsx/components/manage/containers/AnalysisGroups';

class AnalysisGroupAdmin extends FormBase {
  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
    };
  }

  render() {
    return (
      <div className="p-3 h-100">
        <div className="p-1">
            <PageTitle iconName="table" title="Analysis Groups/Periods" />
        </div>
        <AnalysisGroups />
      </div>
    );
  }
}

export default (AnalysisGroupAdmin);
